<div class="contianer">
    <div class="image">
        <img src="assets/img/login.svg" alt="">
    </div>
    <div class="form">
        <ng-content></ng-content>
    </div>
</div>